import React from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, isResponsive, isSmartphone} from "../../components/Utils";
import {SECURITE_BIEN_ETRE_CODE, URL_FOR_RESOURCES} from "../../app/AppConfig";
import {useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {Taxon} from "../Entity/Taxon";

const CategoriesSecurityEquipment = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const taxonsSecurity = useSelector((state: RootState) => state.taxonRdc.taxons);
  const isRequesting = useSelector((state: RootState) => state.taxonRdc.isRequesting);
  const taxonomyParent = SECURITE_BIEN_ETRE_CODE;


  return (
    <div className="container">
      <section className="equipment-security py-4 mt-4">
        <header className="section-heading text-center pb-5">
          <h3 className="section-title h1">{t('equipment_securite_bien_etre')}</h3>
          <p className="lead pt-3 mb-0">Votre partenaire pour l’achat, la location et l’entretien du matériel de sécurité.</p>
        </header>
        <nav className="row gy-3 equal">
          {
            isRequesting ?
              <SpinnerOnTop/>
              :
              taxonsSecurity && taxonsSecurity.filter((a) => a.parentCode === taxonomyParent).map((taxonItem: Taxon, index: number) => {
                return (
                  <div
                    className={!isResponsive && !isSmartphone && (index + 1) % 5 === 0 ? "col col-equipement break-after" : "col col-equipement"}
                    key={taxonItem.code}>
                    <a
                      href={taxonItem.redirectUrl ? taxonItem.redirectUrl : "/" + locale + "/" + t('url_catalogue') + "?" + taxonItem.parentCode + "=" + taxonItem.code}
                      className="card boxed-link" target={taxonItem.redirectUrl && taxonItem.redirectUrl.includes("#") ? "_self" : taxonItem.redirectUrl !== "" ? "_self" : "_blank"}>
                      <div className="py-4 px-2 text-center">
                          <span className="icon-lg mb-3">
                            <img width="72" height="72" src={ URL_FOR_RESOURCES + taxonItem.icon}/>
                          </span>
                        <span className="text">{taxonItem.name} </span>
                      </div>
                    </a>
                  </div>
                )
              })
          }
        </nav>
      </section>
    </div>
  )
}
export default CategoriesSecurityEquipment;
